import React from "react";

function Section({ emoji, title, children }) {
  return (
    <div style={{ marginBottom: 24 }}>
      <div style={{
        display: "flex", alignItems: "center", gap: 10, marginBottom: 10,
        borderBottom: "1px solid rgba(255,107,53,0.2)", paddingBottom: 8,
      }}>
        <span style={{ fontSize: 20 }}>{emoji}</span>
        <div style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 18, color: "#FF6B35", letterSpacing: 1 }}>
          {title}
        </div>
      </div>
      <div style={{ fontSize: 14, color: "rgba(255,255,255,0.7)", lineHeight: 1.7 }}>
        {children}
      </div>
    </div>
  );
}

function Rule({ label, value }) {
  return (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", padding: "8px 0", borderBottom: "1px solid rgba(255,255,255,0.06)" }}>
      <span style={{ color: "rgba(255,255,255,0.45)", fontSize: 13, flex: 1 }}>{label}</span>
      <span style={{ color: "white", fontWeight: 700, fontSize: 13, textAlign: "right", flex: 1 }}>{value}</span>
    </div>
  );
}

export default function UEHowToPlay({ onClose }) {
  return (
    <div style={{
      position: "fixed", inset: 0, zIndex: 1000,
      background: "rgba(0,0,0,0.75)",
      display: "flex", alignItems: "flex-start", justifyContent: "center",
      padding: "20px 16px",
      overflowY: "auto",
    }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div style={{
        background: "linear-gradient(145deg, #0f1e32, #142444)",
        border: "1px solid rgba(255,107,53,0.3)",
        borderRadius: 20, padding: "28px 28px",
        maxWidth: 580, width: "100%",
        position: "relative",
        boxShadow: "0 24px 80px rgba(0,0,0,0.6)",
        margin: "auto",
      }}>
        {/* Close button */}
        <button onClick={onClose} style={{
          position: "absolute", top: 16, right: 16,
          background: "rgba(255,255,255,0.08)", border: "none",
          color: "rgba(255,255,255,0.6)", borderRadius: "50%",
          width: 32, height: 32, cursor: "pointer", fontSize: 16,
          display: "flex", alignItems: "center", justifyContent: "center",
        }}>✕</button>

        {/* Header */}
        <div style={{ marginBottom: 24 }}>
          <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 3, color: "#FF6B35", marginBottom: 6, textTransform: "uppercase" }}>
            Game Guide
          </div>
          <div style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 34, color: "white", letterSpacing: 2, lineHeight: 1 }}>
            HOW TO PLAY<br />
            <span style={{ color: "#FF6B35" }}>UNDERDOG EDGE</span>
          </div>
          <p style={{ fontSize: 14, color: "rgba(255,255,255,0.45)", marginTop: 10, lineHeight: 1.5 }}>
            An NFL season-long pool where you pick one underdog every week and earn points when they pull the upset.
          </p>
        </div>

        {/* The Basics */}
        <Section emoji="🏈" title="The Basics">
          <p style={{ marginBottom: 10 }}>
            Each week of the NFL regular season, you pick <strong style={{ color: "white" }}>one underdog team</strong> from
            the week's games. If your underdog wins the game outright, you earn points equal to the closing spread.
            The entry with the most points at the end of the regular season wins.
          </p>
          <p>
            That's it. No parlays, no point spreads to cover — your team just has to win the game.
          </p>
        </Section>

        {/* Scoring */}
        <Section emoji="📊" title="Scoring">
          <div style={{ background: "rgba(255,107,53,0.08)", borderRadius: 10, padding: "14px 16px", marginBottom: 12 }}>
            <Rule label="Underdog wins outright" value="Points = closing spread at kickoff" />
            <Rule label="Underdog loses" value="0 points" />
            <Rule label="No pick made" value="Auto-assigned MNF underdog" />
          </div>
          <div style={{ background: "rgba(255,255,255,0.03)", borderRadius: 8, padding: "10px 14px", marginBottom: 12, borderLeft: "2px solid rgba(255,107,53,0.3)" }}>
            <p style={{ fontSize: 12, color: "rgba(255,255,255,0.5)", lineHeight: 1.6, margin: 0 }}>
              ↳ <strong style={{ color: "rgba(255,255,255,0.7)" }}>MNF double-header?</strong> The later game's underdog is used for auto-assignment.
            </p>
          </div>
          <p style={{ fontSize: 13, color: "rgba(255,255,255,0.4)" }}>
            Points are based on the <strong style={{ color: "rgba(255,255,255,0.6)" }}>closing spread at kickoff</strong> — not when you made your pick. If the line moves before kickoff, your points move with it.
          </p>
        </Section>

        {/* Pick Rules */}
        <Section emoji="🎯" title="Pick Rules">
          <div style={{ background: "rgba(255,107,53,0.08)", borderRadius: 10, padding: "14px 16px" }}>
            <Rule label="Picks per week" value="1 per entry" />
            <Rule label="Pick deadline" value="Before that game's kickoff" />
            <Rule label="Repeat teams" value="Allowed — any week, any team" />
            <Rule label="Change your pick" value="Anytime before kickoff" />
            <Rule label="Multiple entries" value="Allowed if pool permits" />
          </div>
        </Section>

        {/* Close */}
        <button onClick={onClose} className="btn btn-full" style={{ background: "#FF6B35", color: "white", fontWeight: 700, borderRadius: 10, marginTop: 4 }}>
          Got it — Let's Pick! 🏈
        </button>
      </div>
    </div>
  );
}
